import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaChevronDown } from 'react-icons/fa';

const faqs = [
  {
    question: 'Is this video downloader completely free to use?',
    answer: 'Yes! Our video downloader is 100% free with no hidden charges, subscriptions, or premium features. Download unlimited videos from YouTube, Instagram, Facebook, and TikTok without any cost.',
  },
  {
    question: 'Which platforms are supported by your downloader?',
    answer: 'We currently support YouTube, Instagram, Facebook, and TikTok. You can download videos, reels, stories, and clips from all these platforms in various qualities and formats.',
  },
  {
    question: 'What video qualities and formats are available?',
    answer: 'We offer multiple quality options including HD, Full HD, and 4K (when available). Videos can be downloaded in MP4 format, and we also provide audio-only downloads in MP3 format.',
  },
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <div className="max-w-4xl mx-auto px-4 py-16">
      <div className="space-y-4">
        {faqs.map((faq, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.1 }}
            className="bg-[#1a1a3e] border border-gray-800 rounded-xl overflow-hidden"
          >
            <button
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
              className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-[#20204e] transition-colors"
            >
              <span className="text-white font-semibold text-lg">{faq.question}</span>
              <motion.div
                animate={{ rotate: openIndex === index ? 180 : 0 }}
                transition={{ duration: 0.3 }}
              >
                <FaChevronDown className="text-gray-400" />
              </motion.div>
            </button>

            <AnimatePresence>
              {openIndex === index && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: 'auto', opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.3 }}
                  className="overflow-hidden"
                >
                  <div className="px-6 pb-5 text-gray-400 leading-relaxed">
                    {faq.answer}
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;
